import React, { useState, useEffect, useRef } from 'react';
import debounce from 'lodash.debounce';
import { useDispatch, useSelector } from 'react-redux';
import { companySearch, companyDetail } from '../../store/actions/companySearch';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';

const CompanySearch = ({ formik }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [suggestionsEnabled, setSuggestionsEnabled] = useState(true);
  const wrapperRef = useRef(null);
  const dispatch = useDispatch();

  const companies = useSelector((state) => state.companySearch.companies);
  const loading = useSelector((state) => state.companySearch.loading);
  const error = useSelector((state) => state.companySearch.error);

  // Klik mimo suggestions = zatvorenie
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setShowSuggestions(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Debounce vyhľadávanie
  const debouncedSearch = useRef(
    debounce((value) => {
      if (value.length >= 3 && suggestionsEnabled) {
        dispatch(companySearch(value));
      }
    }, 700)
  ).current;

  useEffect(() => {
    if (showSuggestions) {
      debouncedSearch(searchTerm);
    }
}, [searchTerm, showSuggestions, suggestionsEnabled]);


  const handleCompanyClick = (company) => {
    dispatch(companyDetail(company));
    formik.setFieldValue('companyName', company.companyName);
    setSearchTerm(company.companyName);
    setShowSuggestions(false);
  };

  const escapeRegex = (text) => {
    return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  };

  const highlightMatch = (text) => {
    try {
      const escapedSearch = escapeRegex(searchTerm);
      const regex = new RegExp(`(${escapedSearch})`, 'gi');
      return text.split(regex).map((part, i) =>
        part.toLowerCase() === searchTerm.toLowerCase() ? <mark key={i}>{part}</mark> : part
      );
    } catch (e) {
      console.error('Chybný regex vo highlightMatch:', e.message);
      return text;
    }
};

  const errorHelper = (formik, fieldName) => ({
    error: formik.touched[fieldName] && Boolean(formik.errors[fieldName]),
    helperText: formik.touched[fieldName] && formik.errors[fieldName],
  });

  return (
    <div ref={wrapperRef}>
      {/* Toggle suggestions */}
      <div className="mb-2">
        <button
          type="button"
          onClick={() => setSuggestionsEnabled((prev) => !prev)}
          style={{
            fontSize: '0.9rem',
            background: 'none',
            border: 'none',
            color: '#007bff',
            cursor: 'pointer',
            padding: 0,
          }}
        >
          {suggestionsEnabled ? 'Skryť nápovedu' : 'Zobraziť nápovedu'}
        </button>
      </div>

      {/* Company name */}
      <Form.Group className="mb-3" controlId="formBasicCompanyName">
        <Form.Label>Názov spoločnosti/obce/živnosti*</Form.Label>
        <Form.Control
          type="text"
          placeholder="Zadajte názov spoločnosti/obce/živnosti"
          {...formik.getFieldProps('companyName')}
          isInvalid={errorHelper(formik, 'companyName').error}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setShowSuggestions(true);
            formik.handleChange(e);
          }}
        />
        <Form.Control.Feedback type="invalid">
          {errorHelper(formik, 'companyName').helperText}
        </Form.Control.Feedback>
      </Form.Group>

      {/* Loading */}
      {loading && (
        <div className="mb-2 d-flex align-items-center">
          <Spinner animation="border" size="sm" />
          <span className="ms-2">Načítavam...</span>
        </div>
      )}

      {/* Error */}
      {error && <p style={{ color: 'red' }}>{error}</p>}

      {/* Suggestions */}
      {showSuggestions && suggestionsEnabled && searchTerm.trim() !== '' && companies.length > 0 && (
        <ul style={{ listStyle: 'none', padding: 0, border: '1px solid #ccc', borderRadius: '5px' }}>
          {companies.map((company) => (
            <li
              key={company._id}
              onClick={() => handleCompanyClick(company)}
              style={{
                cursor: 'pointer',
                padding: '5px 10px',
                borderBottom: '1px solid #ddd',
              }}
            >
              {highlightMatch(company.companyName)}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CompanySearch;
